<script>
    import {
        SvelteTable,
        Button,
        CardLayout,
        NotificationModal,
    } from "../../../../../Components/Common/index.svelte";

    import { apiMethods } from "../../../../../Services/index.svelte";

    import { addIcon } from "../../../../../Utils/utilConstants.svelte";

    import {
        getFormatDateAndTime,
        getMobileValidation,
        turnOnEncounterNotification,
        showError,
        showException,
        getTitle,
        getCommsStatusText,
        showInfo
    } from "../../../../../Utils/utilFunctions.svelte";

    import CreateNotificationModal from "../../../../PatientEncounter/components/CreateNotificationModal.svelte";

    export let patientEncounterDetails = {};
    export let smsNotifications = [];
    export let patientDetails = {};
    export let doctorDetails = {};
    export let reloadCommunication = () => {};

    $: isPatientPhoneValid = patientEncounterDetails.patient?.phone
        ? getMobileValidation(patientEncounterDetails.patient.phone)
        : false;

    $: btnOptions = [
        {
            iconName: "aboutToCallIcon",
            iFont: addIcon,
            iconFunction: () => _openAboutToCallNotificationModal(),
            btnText: "About to Call",
            isDisabled: !isPatientPhoneValid,
            hasTooltip: !isPatientPhoneValid,
            tooltip:
                "Patient phone is invalid, please correct before add SMS notification",
        },
        {
            iconName: "addIcon",
            iFont: addIcon,
            iconFunction: () => _openCreateNotificationModal(),
            btnText: "Compose",
            isDisabled: !isPatientPhoneValid,
            hasTooltip: !isPatientPhoneValid,
            tooltip:
                "Patient phone is invalid, please correct before add SMS notification",
        },
    ];

    let isResendingSMS = false,
        showResendSmsFinishModal = false;

    let isShowAddNotificationModal = false,
        notificationObj = {},
        isCreatingNotification = false;

    let isNoteModalOpen = false;

    let showResendFailModal = false,
        currentComm,
        isCancellingComm = false,
        isCancelCommModalOpen = false,
        isSendingNow = false,
        isSendNowModalOpen = false;

    const columns = [
        {
            key: "dateToSend",
            title: "Date to Send",
            headerClass: "text-left pl-3 cursor-default rounded-tl-xl w-[10%]",
            class: "text-left px-3 cursor-default w-[10%]",
            value: (v) => _getFormatDate(v.dateToSend),
        },
        {
            key: "mobileNumber",
            title: "Mobile Number",
            headerClass: "text-left pl-3 cursor-default w-[15%]",
            class: "text-left px-3 cursor-default w-[15%]",
            renderValue: (v) => _getMobileNumber(v.countryCode, v.mobileNumber),
        },
        {
            key: "content",
            title: "Content",
            headerClass: "text-left pl-3 cursor-default w-[55%]",
            class: "text-left pl-3 cursor-default w-[55%]",
            renderValue: (v) => _getContent(v.content),
        },
        {
            key: "status",
            title: "Status",
            headerClass: "text-left pl-3 cursor-default w-[10%]",
            class: "text-left px-3 cursor-default w-[10%]",
            renderValue: (v) => getCommsStatusText(v.status),
        },
        {
            key: "actions",
            title: "Actions",
            headerClass:
                "text-center pr-3 cursor-default w-[10%] rounded-tr-xl",
            class: "text-left px-3 cursor-pointer w-[10%]",
            renderValue: (v) => _renderActionIcons(v),
        },
    ];

    const handleClickCell = ({ target: { className } }, rowData, key) => {
        if (key == "actions"){
            if (className.includes("sendIcon")) reSendSMS(rowData);
            if (className.includes("cancelIcon")) askCancel(rowData);
            if (className.includes("sendNowIcon")) askSendNow(rowData);
        }
    };

    const askCancel = (data) => {
        if (!data.id) return;
        currentComm = data;
        isCancelCommModalOpen = true;        
    }

    const cancelCurrentComm = async () => {
        if (!currentComm.id) return;
        isCancellingComm = true;

        await apiMethods.postMethod
            .cancelEncounterCommunication({
                patientEncounterId: currentComm.patientEncounterId,
                smsId: currentComm.id,
            })
            .then((res) => {
                if (res === true) {
                    showInfo("SMS Cancelled");
                    reloadCommunication();
                    closeCancelCommModal();
                }
            })
            .catch((err) => showException(err));

        isCancellingComm = false;
    }

    const closeCancelCommModal = () => {
        currentComm = undefined;
        isCancelCommModalOpen = false;
    }

    
    const askSendNow = (data) => {
        if (!data.id) return;
        currentComm = data;
        isSendNowModalOpen = true;        
    }

    const sendCommsNow = async () => {
        if (!currentComm.id) return;

        isSendingNow = true;

        await apiMethods.postMethod
            .sendEncounterCommunicationNow({
                patientEncounterId: currentComm.patientEncounterId,
                smsId: currentComm.id,
            })
            .then((res) => {
                if (res === true) {
                    showInfo("SMS Sent to Patient");
                    reloadCommunication();
                    closeSendNowModal();
                }
            })
            .catch((err) => showException(err));

        isSendingNow = false;
    }

    const closeSendNowModal = () => {
        currentComm = undefined;
        isSendNowModalOpen = false;
    }

    const handleClickCol = ({ target: { className } }, colData, key) => {};

    const createNotification = () => {
        if (patientEncounterDetails.disableNotifications) {
            isNoteModalOpen = true;
        } else {
            createNotificationAction();
        }
    };

    const enableComAndCreateNote = async () => {
        isCreatingNotification = true;
        await turnOnEncounterNotification(patientEncounterDetails);
        createNotificationAction();
    };

    const createNotificationAction = async () => {
        isCreatingNotification = true;

        const { id, doctorId, patientId } = patientEncounterDetails;

        notificationObj = {
            ...notificationObj,
            doctorId,
            patientId,
            patientEncounterId: id,
        };

        await apiMethods.postMethod
            .createNotification("sms", notificationObj)
            .then((res) => _handleCreateNotification(res))
            .catch((err) => showException(err));

        _closeCreateNotificationModal();

        isCreatingNotification = false;
    };

    const reSendSMS = async (data) => {
        isResendingSMS = true;

        await apiMethods.postMethod
            .resentEncounterNotification({
                patientEncounterId: data.patientEncounterId,
                smsId: data.id,
            })
            .then((res) => _handleResendSMS(res))
            .catch((err) => showException(err));

        isResendingSMS = false;
    };

    const closeResendSmsFinishModal = () => {
        showResendSmsFinishModal = false;

        reloadCommunication();
    };

    // HELPER FUNCTIONS
    const _handleCreateNotification = (res) => {
        isNoteModalOpen = false;
        const result = JSON.stringify(res);
        if (result == "true") reloadCommunication();
        else
            showError(
                res.error ??
                    "Failed to create SMS notification, please refresh the page and try again and contact support if the issue persists.",
            );
    };

    const _handleResendSMS = (res) => {
        const result = JSON.stringify(res);
        if (result == "true") showResendSmsFinishModal = true;
        else _openResendFailModal();
    };

    const _getFormatDate = (date) => {
        if (date == "0001-01-01T00:00:00") return "-";

        return getFormatDateAndTime(date);
    };

    const _getMobileNumber = (countryCode, mobileNum) => {
        return `${
            countryCode.substring(0, 1) == "+" ? "" : "+"
        }${countryCode} - ${mobileNum}`;
    };

    const _getContent = (content) => {
        return `<div class="max-w-[400px]">${content}</div>`;
    };

    const _openCreateNotificationModal = () => {
        _resetNotificationObj();
        isShowAddNotificationModal = true;
    };

    const _openAboutToCallNotificationModal = () => {
        const patientName = patientDetails.firstName
            ? patientDetails.firstName
            : patientDetails.lastName
              ? patientDetails.lastName
              : "";
        const doctorName = `${getTitle(doctorDetails.title)} ${doctorDetails.fullName}`;

        const content = `Hello ${patientName},\nWe will call you shortly to discuss your Anaesthesia service provided by ${doctorName}. The call may come from an unknown number.\nBest regards.`;

        _resetNotificationObj(content);
        isShowAddNotificationModal = true;
    };

    const _closeCreateNotificationModal = () => {
        _resetNotificationObj();
        isShowAddNotificationModal = false;
    };

    const _resetNotificationObj = (content = "") => {
        notificationObj = {
            content,
        };
    };

    const _renderActionIcons = (v) => {
        return v.status === 0 ? 
            `<div class="flex flex-1 items-center justify-end gap-x-2"> 
                <div class="cancelIcon tooltip tooltip-secondary tooltip-left flex items-center justify-center w-[30px] h-[30px] hover:rounded-full hover:bg-secondary hover:text-white" data-tip="Cancel SMS">
                    <i class="cancelIcon fa fa-times"></i>
                </div>
                <div class="sendNowIcon tooltip tooltip-secondary tooltip-left flex items-center justify-center w-[30px] h-[30px] hover:rounded-full hover:bg-secondary hover:text-white" data-tip="Send SMS Now">
                    <i class="sendNowIcon fa fa-paper-plane"></i>
                </div>
                <div class="sendIcon tooltip tooltip-secondary tooltip-left flex items-center justify-center w-[30px] h-[30px] hover:rounded-full hover:bg-secondary hover:text-white" data-tip="Resend SMS">
                    <i class="sendIcon fa-solid fa-comment"></i>
                </div>
            </div>` :
            `<div class="flex flex-1 items-center justify-end gap-x-2"> 
                <div class="sendIcon tooltip tooltip-secondary tooltip-left flex items-center justify-center w-[30px] h-[30px] hover:rounded-full hover:bg-secondary hover:text-white" data-tip="Resend SMS">
                    <i class="sendIcon fa-solid fa-comment"></i>
                </div>
            </div>`
        ;
    };

    const _openResendFailModal = () => (showResendFailModal = true);

    const _closeResendFailModal = () => (showResendFailModal = false);
</script>

<CardLayout title="SMS Notifications" {btnOptions}>
    <div class="h-full flex flex-col w-full lg:flex-row">
        {#if smsNotifications.length}
            <div class="w-full overflow-x-auto">
                <SvelteTable
                    {columns}
                    rows={smsNotifications}
                    clickCellFunc={({ detail: { event, row, key } }) => {
                        handleClickCell(event, row, key);
                    }}
                    clickColFunc={({ detail: { event, row, key } }) => {
                        handleClickCol(event, row, key);
                    }}
                />
            </div>
        {:else}
            <div
                class="flex flex-col flex-1 px-2 py-4 w-full bg-white rounded-b-2xl lg:flex-row"
            >
                <p>
                    No SMS notifications currently under this Patient encounter
                </p>
            </div>
        {/if}
    </div>
</CardLayout>

<CreateNotificationModal
    type="sms"
    bind:notificationObj
    isModalOpen={isShowAddNotificationModal}
    {isCreatingNotification}
    closeModal={_closeCreateNotificationModal}
    {createNotification}
/>

<NotificationModal
    isModalOpen={showResendSmsFinishModal}
    showCancelBtn={false}
    submitText="Done"
    confirmAction={closeResendSmsFinishModal}
    closeModalFunction={closeResendSmsFinishModal}
>
    SMS Re-sent
</NotificationModal>

<NotificationModal
    isModalOpen={isNoteModalOpen}
    submitText="Turn on and send"
    cancelText="Save without sending"
    closeModal={createNotificationAction}
    confirmAction={enableComAndCreateNote}
    isConfirming={isCreatingNotification}
>
    Notifications is turned off for this patient.
</NotificationModal>

<NotificationModal
    isModalOpen={showResendFailModal}
    cancelText="Close"
    closeModal={_closeResendFailModal}
    showConfirmBtn={false}
    title="Unable to resend SMS"
    closeModalFunction={_closeResendFailModal}
>
    <p class="leading-6">
        Please check the quote details and communication settings.
    </p>
    <p class="leading-6">Please contact support if the issue persists.</p>
</NotificationModal>

<NotificationModal
    isModalOpen={isCancelCommModalOpen}
    submitText="Close"
    confirmButtonClass="btn-accent"
    cancelText="Confirm"
    confirmAction={closeCancelCommModal}
    closeModalFunction={closeCancelCommModal}
    closeModal={cancelCurrentComm}
    title="Cancel SMS"
    isReverseBtns
    isConfirming={isCancellingComm}
>
    Cancel this SMS?
</NotificationModal>

<NotificationModal
    isModalOpen={isSendNowModalOpen}
    submitText="Cancel"
    cancelText="Confirm"
    confirmAction={closeSendNowModal}
    closeModalFunction={closeSendNowModal}
    closeModal={sendCommsNow}
    title="Send Now"
    isReverseBtns
    isConfirming={isSendingNow}
>
    Send this SMS now?
</NotificationModal>